import { useState } from 'react';
import { useConnect } from '@lore/query-connect';
import { parse } from 'query-string';
import moment from 'moment-timezone';
import useStewardshipFilter from '../../evaluations-project-educators/useStewardshipFilter';
import getQueryUtils, { attributeKeys } from '../../evaluations-project-educators/queryUtils';

export default function useQuery(props) {
  const {
    search = {},
    pageSize = 10,
    network,
    schoolStart,
    schoolEnd
  } = props;

  const [timestamp] = useState(moment().toISOString());
  const stewardshipFilter = useStewardshipFilter();

  const queryUtils = getQueryUtils(search, attributeKeys, timestamp);

  return useConnect('evaluationProjectEducator.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfUploads',
            relation: 'uploads'
          }
        ],
        $where: {
          $and: [...queryUtils.where],
          completed: true,
          $or: stewardshipFilter,
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          }
        },
        $having: {
          $and: [...queryUtils.having]
        }
      }
    },
    pagination: {
      page: parse(location.search).page || '1',
      pageSize: pageSize,
      order: search.order || 'createdAt desc'
    }
  }, {
    keepPreviousData : true
  });
}
